import { OP } from "../../constant";

// merchant list
export function fetchMerchantRequest(token) {
  return {
    type: OP.MERCHANT_LIST_REQUEST,
    payload: {
      token,
    },
  };
}

export function fetchMerchantReset() {
  return {
    type: OP.MERCHANT_LIST_RESET,
  };
}

//add merchant
export function addMerchantRequest(token, data) {
  return {
    type: OP.ADD_MERCHANT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function addMerchantReset() {
  return {
    type: OP.ADD_MERCHANT_RESET,
  };
}

// create merchant account
export function createMerchantAccountRequest(token, data) {
  return {
    type: OP.CREATE_MERCHANT_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function createMerchantAccountReset() {
  return {
    type: OP.CREATE_MERCHANT_ACCOUNT_RESET,
  };
}

// update merchant account
export function updateMerchantAccountRequest(token, data) {
  return {
    type: OP.UPDATE_MERCHANT_ACCOUNT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function updateMerchantAccountReset() {
  return {
    type: OP.UPDATE_MERCHANT_ACCOUNT_RESET,
  };
}

//view merchant
export function viewMerchantRequest(token, data) {
  return {
    type: OP.VIEW_MERCHANT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function viewMerchantReset() {
  return {
    type: OP.VIEW_MERCHANT_RESET,
  };
}

//activate merchant
export function activateMerchantRequest(token, data) {
  return {
    type: OP.ACTIVATE_MERCHANT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function activateMerchantReset() {
  return {
    type: OP.ACTIVATE_MERCHANT_RESET,
  };
}

//deactivate merchant
export function deactivateMerchantRequest(token, data) {
  return {
    type: OP.DEACTIVATE_MERCHANT_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function deactivateMerchantReset() {
  return {
    type: OP.DEACTIVATE_MERCHANT_RESET,
  };
}

//merchant transactions list
export function fetchMerchantTransactionsRequest(token, data) {
  return {
    type: OP.MERCHANT_TRANSACTIONS_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function fetchMerchantTransactionsReset() {
  return {
    type: OP.MERCHANT_TRANSACTIONS_RESET,
  };
}

//view one merchant transaction
export function viewMerchantTransactionRequest(token, data) {
  return {
    type: OP.VIEW_MERCHANT_TRANSACTION_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function viewMerchantTransactionReset() {
  return {
    type: OP.VIEW_MERCHANT_TRANSACTION_RESET,
  };
}

// merchant properties
export function merchantPropertiesRequest(token, data) {
  return {
    type: OP.MERCHANT_PROPERTIES_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function merchantPropertiesReset() {
  return {
    type: OP.MERCHANT_PROPERTIES_RESET,
  };
}

// create merchant property
export function createMerchantPropertyRequest(token, data) {
  return {
    type: OP.CREATE_MERCHANT_PROPERTY_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function createMerchantPropertyReset() {
  return {
    type: OP.CREATE_MERCHANT_PROPERTY_RESET,
  };
}

// update merchant property
export function updateMerchantPropertyRequest(token, data) {
  return {
    type: OP.UPDATE_MERCHANT_PROPERTY_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function updateMerchantPropertyReset() {
  return {
    type: OP.UPDATE_MERCHANT_PROPERTY_RESET,
  };
}

// delete merchant property
export function deleteMerchantPropertyRequest(token, data) {
  return {
    type: OP.DELETE_MERCHANT_PROPERTY_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function deleteMerchantPropertyReset() {
  return {
    type: OP.DELETE_MERCHANT_PROPERTY_RESET,
  };
}
